export interface IFooterBlock {
  header?: string;
  links?: {
    name?: string;
    url?: string;
    fontWeight?: number;
    view?: string;
    section?: string;
    color?: string;
    icon?: string;
  }[];
  subHeaders?: IFooterBlock[];
}

interface IFooterData {
  [country: string]: IFooterBlock[];
}

export interface IPartnersLevels {
  [key: string]: {
    value: number;
    name: string;
    percent: number;
    color: string;
    description: string;
  }
}

export interface IReviews {
  description: string;
  name: string;
  position: string;
  photo: string;
  size: string;
}

export interface IGettings {
  header: string;
  description: string;
  color: string;
}

export interface IDocuments {
  format: string;
  title: string;
  link: string;
}

export interface IMenuLinks {
  route?: string;
  name: string;
  links?: IMenuLinks[]
}

export const phoneNums = {
  salesDepartment: {
    formatted: '+7 (495) 148-50-22',
    value: '+74951485022'
  },
  salesDepartmentUZ: {
    formatted: '+998 (78) 113-66-61',
    value: '+998781136661'
  },
  salesDepartmentKZ: {
    formatted: '+7 (708) 905-70-02',
    value: '+77089057002'
  },
  partnerDepartment: {
    formatted: '+7 (495) 148-50-11',
    value: '+74951485011'
  },
  partnerDepartmentUZ: {
    formatted: '+998 (78) 113-66-68',
    value: '+998781136668'
  }
}

export const getMenuLinks = (): IMenuLinks[] => {
  return [
    {
      route: 'https://onlinepbx.ru/',
      name: 'Главная'
    },
    {
      name: 'Возможности',
      links: [
        {
          route: '/features/chats',
          name: 'Чаты',
        },
        {
          route: '/features',
          name: 'Телефония',
        }
      ]
    },
    {
      route: '/stories',
      name: 'Кейсы'
    },
    {
      route: '/partners',
      name: 'Партнерам'
    },
    {
      route: 'https://onlinepbx.ru/cost',
      name: 'Цена'
    },
    {
      route: '/help',
      name: 'Помощь'
    },
  ]
}

const footerBlocks = [
  {
    header: 'Продукт',
    links: [
      {
        name: 'Главная',
        url: 'https://onlinepbx.ru/',
        fontWeight: 400,
        view: ''
      },
      {
        name: 'Возможности',
        url: '',
        fontWeight: 400,
        view: 'features'
      },
      {
        name: 'Цена',
        url: 'https://onlinepbx.ru/cost',
        fontWeight: 400,
        view: 'price'
      },
      {
        name: 'Партнерская программа',
        url: '',
        fontWeight: 400,
        view: 'partners'
      },
      {
        name: 'Кейсы',
        url: '',
        fontWeight: 400,
        view: 'stories'
      }
    ]
  },
  {
    header: 'Ресурсы',
    links: [
      {
        name: 'База знаний',
        url: 'https://onlinepbx.evateam.ru/docs/docs/CmfProject:e6966c84-48a9-11ee-848f-00161e050156#baza-znanij-online-pbx',
        fontWeight: 400,
        view: ''
      },
      {
        name: 'Блог',
        url:
          'http://blog.onlinepbx.ru/?utm_source=onlinepbx.ru&utm_medium=footer&utm_campaign=onlinepbx#_ga=2.161848373.827584279.1578900772-93906433.1578900772',
        fontWeight: 400,
        view: ''
      },
      {
        name: 'Помощь',
        url: '',
        fontWeight: 400,
        view: 'help'
      },
      {
        name: 'API',
        url: 'https://onlinepbx.evateam.ru/docs/docs/DOC-000051#api',
        fontWeight: 400,
        view: ''
      }
    ]
  },
  {
    header: 'Компания',
    links: [
      {
        name: 'О компании',
        url: '',
        fontWeight: 400,
        view: 'about'
      },
      {
        name: 'Документы',
        url: '',
        fontWeight: 400,
        view: 'docs'
      },
      {
        name: 'Контакты',
        url: '',
        fontWeight: 400,
        view: 'contacts'
      }
    ]
  },
];

export const getFooterBlocks = (country: string): IFooterBlock[] => {
  const footerData: IFooterData = {
    RU: [
      ...footerBlocks,
      {
        header: 'Контакты',
        subHeaders: [
          {
            header: 'Отдел продаж',
            links: [
              {
                name: 'go@onlinepbx.ru',
                url: 'mailto:go@onlinepbx.ru',
                fontWeight: 400,
                view: ''
              },
              {
                name: phoneNums.salesDepartment.formatted,
                url: `tel:${phoneNums.salesDepartment.value}`,
                fontWeight: 400,
                view: ''
              }
            ]
          },
          {
            header: 'Партнерский отдел',
            links: [
              {
                name: 'partner@onlinepbx.ru',
                url: 'mailto:partner@onlinepbx.ru',
                fontWeight: 400,
                view: ''
              },
              {
                name: phoneNums.partnerDepartment.formatted,
                url: `tel:${phoneNums.partnerDepartment.value}`,
                fontWeight: 400,
                view: ''
              }
            ]
          },
          {
            header: 'Бухгалтерия',
            links: [
              {
                name: 'fin@onlinepbx.ru',
                url: 'mailto:fin@onlinepbx.ru',
                fontWeight: 400,
                view: ''
              }
            ]
          },
        ]
      },
      {
        header: ' ',
        subHeaders: [
          {
            header: 'Техподдержка',
            links: [
              {
                name: 'support@onlinepbx.ru',
                url: 'mailto:support@onlinepbx.ru',
                fontWeight: 400,
                view: ''
              },
              {
                name: '+7 (495) 669-67-21',
                url: 'tel:+74956696721',
                fontWeight: 400,
                view: ''
              },
              {
                name: '+7 (812) 646-51-40',
                url: 'tel:+78126465140',
                fontWeight: 400,
                view: ''
              },
              {
                name: '+7 (343) 302-01-37',
                url: 'tel:+73433020137',
                fontWeight: 400,
                view: ''
              },
              {
                name: 'Telegram: @onpbx_calls (для звонков)',
                url: 'https://t.me/onpbx_calls',
                fontWeight: 400,
                view: ''
              },
              {
                name: 'Telegram: @techpbx_bot (для чатов)',
                url: 'https://t.me/techpbx_bot',
                fontWeight: 400,
                view: ''
              }
            ]
          }
        ]
      }
    ],
    KZ: [
      ...footerBlocks,
      {
        header: 'Контакты',
            links: [
              {
                name: phoneNums.salesDepartmentKZ.formatted,
                url: `tel:${phoneNums.salesDepartmentKZ.value}`,
                fontWeight: 400,
                view: ''
              },
              {
                name: 'go@onlinepbx.ru',
                url: 'mailto:go@onlinepbx.ru',
                fontWeight: 400,
                view: '',
                section: 'отдел продаж'
              },
              {
                name: 'partner@onlinepbx.ru',
                url: 'mailto:partner@onlinepbx.ru',
                fontWeight: 400,
                view: '',
                section: 'партнерский отдел'
              },
              {
                name: 'fin@onlinepbx.ru',
                url: 'mailto:fin@onlinepbx.ru',
                fontWeight: 400,
                view: '',
                section: 'бухгалтерия'
              },
              {
                name: 'support@onlinepbx.ru',
                url: 'mailto:support@onlinepbx.ru',
                fontWeight: 400,
                view: '',
                section: 'техподдержка'
              }
            ]
      }
    ],
    UZ: [
      ...footerBlocks,
      {
        header: 'Контакты',
            links: [
              {
                name: phoneNums.salesDepartmentUZ.formatted,
                url: `tel:${phoneNums.salesDepartmentUZ.value}`,
                fontWeight: 400,
                view: ''
              },
              {
                name: 'go@onlinepbx.ru',
                url: 'mailto:go@onlinepbx.ru',
                fontWeight: 400,
                view: '',
                section: 'отдел продаж'
              },
              {
                name: 'partner@onlinepbx.ru',
                url: 'mailto:partner@onlinepbx.ru',
                fontWeight: 400,
                view: '',
                section: 'партнерский отдел'
              },
              {
                name: 'fin@onlinepbx.ru',
                url: 'mailto:fin@onlinepbx.ru',
                fontWeight: 400,
                view: '',
                section: 'бухгалтерия'
              },
              {
                name: 'support@onlinepbx.ru',
                url: 'mailto:support@onlinepbx.ru',
                fontWeight: 400,
                view: '',
                section: 'техподдержка'
              },
            ]
      },
    ],
  };

  return footerData[country] || [];
};

export const dividedByThree = (num: number, addSymbol = ',') => {
  const parts = (num + '').split('.')
  const main = Array.from(parts[0]).reverse()
  const output = main.map((char, index) => (index + 1 !== main.length && (index + 1) % 3 === 0 ? addSymbol + char : char)).reverse().join('')
  return parts.length > 1 ? output + '.' + parts.slice(1).join('.') : output
}

export const getPartnersLevels = (): IPartnersLevels => {
  return {
    10: {
      value: 10,
      percent: 20,
      name: 'Чаты',
      color: 'linear-gradient(140.19deg, #B7B7B7 0%, rgba(255, 255, 255, 0) 100%), #EAE6E1',
      description: '10% от оплат клиентов \nза чаты Telegram и WhatsApp'
    },
    20: {
      value: 20,
      percent: 30,
      name: 'Телефония',
      color: 'linear-gradient(140.19deg, #C3BB95 0%, rgba(255, 255, 255, 0) 100%), #F8F1D1',
      description: '20% от всех оплат клиентов \nза услуги телефонии'
    }
  }
}

export const getReviews = (): IReviews[] => {
  return [
    {
      size: '18px',
      description:
        'C onlinepbx сотрудничаем уже много лет и за это время они зарекомендовали себя как стабильный сервис с широким функционалом, а так же показали профессионализм техподдержки в решении клиентских задач.',
      name: 'Алексей Петров,',
      position: 'руководитель компании',
      photo: process.env.PUBLIC_DIR + '/images/webregata-review.png'
    },
    {
      size: '14px',
      description:
        'Мы являемся не только партнерами onlinePBX, но и сами используем её в ежедневной работе уже более 4 лет. Сервис показал себя стабильным, какие-либо сбои являются большой редкостью. Особенно радует адекватная техническая поддержка, которая способна решить абсолютно любую задачу. Сам сервис постоянно развивается и появляется что-то новое.',
      name: 'Константин Кузнецов,',
      position: 'генеральный директор',
      photo: process.env.PUBLIC_DIR + '/images/rocketsales-review.png'
    },
    {
      size: '18px',
      description:
        'Возможность подключения сразу нескольких внешних номеров позволяет использовать разные номера телефонов и разных операторов связи, настраивая логику внутри onlinepbx.',
      name: 'Хуршед Нурматов,',
      position: 'генеральный директор',
      photo: process.env.PUBLIC_DIR + '/images/loftylab-review.png'
    }
  ]
}

export const gettingDict = {
  RU: [
    [
      {
        header: 'до 20% от оплат клиентов',
        description: '10% — за подключение чатов; \n20% — за подключение \nуслуг телефонии;',
        color: '#AAB1FF'
      },
      {
        header: 'Возможность оплатить аккаунт \nклиента за вычетом \nвознаграждения',
        description: 'комиссия сразу остается у вас',
        color: '#EFA5DF'
      },
    ],
    [
      {
        header: 'Статистика по клиентам',
        description: 'В личном кабинете храним \nинформацию по клиентам \nи вознаграждениям',
        color: '#FFC90C'
      },
      {
        header: 'Возможность выполнить \nнастройки клиентам',
        description: 'переход из своего ЛК в ЛК клиента \nдля выполнения настроек',
        color: '#00C69E'
      },
    ]
  ],
  KZ: [
    [
      {
        header: 'до 20% от оплат клиентов',
        description: 'за подключение чатов \nи услуг телефонии',
        color: '#AAB1FF'
      },
      {
        header: 'Возможность оплатить аккаунт \nклиента за вычетом \nвознаграждения',
        description: 'комиссия сразу остается у вас',
        color: '#EFA5DF'
      },
    ],
    [
      {
        header: 'Статистика по клиентам',
        description: 'В личном кабинете храним \nинформацию по клиентам \nи вознаграждениям',
        color: '#FFC90C'
      },
      {
        header: 'Возможность выполнить \nнастройки клиентам',
        description: 'переход из своего ЛК в ЛК клиента \nдля выполнения настроек',
        color: '#00C69E'
      },
    ]
  ],
  UZ: [
    [
      {
        header: 'до 20% от оплат клиентов',
        description: 'за подключение чатов \nи услуг телефонии',
        color: '#AAB1FF'
      },
      {
        header: 'Возможность оплатить аккаунт \nклиента за вычетом \nвознаграждения',
        description: 'комиссия сразу остается у вас',
        color: '#EFA5DF'
      },
    ],
    [
      {
        header: 'Статистика по клиентам',
        description: 'В личном кабинете храним \nинформацию по клиентам \nи вознаграждениям',
        color: '#FFC90C'
      },
      {
        header: 'Возможность выполнить \nнастройки клиентам',
        description: 'переход из своего ЛК в ЛК клиента \nдля выполнения настроек',
        color: '#00C69E'
      },
    ]
  ],
}

export const docDict = {
  oferta: [
    {
      format: 'PDF',
      title: 'Политика обработки персональных данных',
      link: process.env.PUBLIC_DIR + '/privacy/conf.pdf'
    },
    {
      format: 'PDF',
      title: 'Лицензионный договор в форме публичной оферты на использование программного продукта "onlinePBX".',
      link: process.env.PUBLIC_DIR + '/privacy/oferta4-0.pdf'
    },
    {
      format: 'PDF',
      title: 'Соглашение об участии в партнерских программах. Публичная оферта.',
      link: 'https://partners.onlinepbx.ru/files/oferta.pdf'
    },
    {
      format: 'PDF',
      title: 'Сводная ведомость результатов проведения специальной оценки условий труда 2019 года',
      link: process.env.PUBLIC_DIR + '/privacy/regulations_2019.pdf'
    },
    {
      format: 'PDF',
      title: 'Сводная ведомость результатов проведения специальной оценки условий труда 2022 года',
      link: process.env.PUBLIC_DIR + '/privacy/regulations_2022.pdf'
    }
  ],
  licenses: [
    {
      format: 'PDF',
      title: 'Свидетельство о постановке на учет в налоговой (ИНН)',
      link: process.env.PUBLIC_DIR + '/privacy/inn.pdf'
    },
    {
      format: 'PDF',
      title: 'Свидетельство о гос.регистрации юр.лица (ОГРН)',
      link: process.env.PUBLIC_DIR + '/privacy/ogrn.pdf'
    },
    {
      format: 'PDF',
      title: 'Устав ООО Тесла телеком в ред. 07.08.2017',
      link: process.env.PUBLIC_DIR + '/privacy/ustav.pdf'
    },
    {
      format: 'PDF',
      title: 'Письмо о применении УСНО',
      link: process.env.PUBLIC_DIR + '/privacy/usno.pdf'
    },
    {
      format: 'PDF',
      title: 'Статус налогового резидента РФ 2025 для Армении',
      link: process.env.PUBLIC_DIR + '/privacy/nalog_am.PDF'
    },
    {
      format: 'PDF',
      title: 'Статус налогового резидента РФ 2025 для Беларуси',
      link: process.env.PUBLIC_DIR + '/privacy/nalog_by.PDF'
    },
    {
      format: 'PDF',
      title: 'Статус налогового резидента РФ 2025 для Казахстана',
      link: process.env.PUBLIC_DIR + '/privacy/nalog_kz.PDF'
    },
    {
      format: 'PDF',
      title: 'Статус налогового резидента РФ 2025 для Узбекистана',
      link: process.env.PUBLIC_DIR + '/privacy/nalog_uz.PDF'
    }
  ]
}

export const getFooterBlocksUZ = (): IFooterBlock[] => {
  return [
    {
      subHeaders: [
        {
          header: 'Техподдержка',
          links: [
            {
              name: 'support@onlinepbx.uz',
              url: 'mailto:support@onlinepbx.uz',
              fontWeight: 400,
              view: ''
            },
            {
              name: '+998 (78) 113-26-50',
              url: 'tel:+998781132650',
              fontWeight: 400,
              view: ''
            },
            {
              name: 'telegram_bot',
              url: 'https://t.me/onpbxuz_bot',
              fontWeight: 400,
              view: '',
              color: '#0D71D7'
            }
          ]
        }
      ]
    },
    {
      header: '',
      subHeaders: [
        {
          header: 'Отдел продаж',
          links: [
            {
              name: 'go@onlinepbx.uz',
              url: 'mailto:go@onlinepbx.uz',
              fontWeight: 400,
              view: ''
            },
            {
              name: phoneNums.salesDepartmentUZ.formatted,
              url: `tel:${phoneNums.salesDepartmentUZ.value}`,
              fontWeight: 400,
              view: ''
            },
            {
              name: 'telegram_chat',
              url: 'https://t.me/onlinepbx_sales',
              fontWeight: 400,
              view: '',
              color: '#0D71D7'
            }
          ]
        }
      ]
    },
    {
      header: '',
      subHeaders: [
        {
          header: 'Партнерский отдел',
          links: [
            {
              name: 'partner@onlinepbx.uz',
              url: 'mailto:partner@onlinepbx.uz',
              fontWeight: 400,
              view: ''
            },
            {
              name: phoneNums.partnerDepartmentUZ.formatted,
              url: `tel:${phoneNums.partnerDepartmentUZ.value}`,
              fontWeight: 400,
              view: ''
            },
            {
              name: 'telegram_chat',
              url: 'https://t.me/onlinepbx_sales',
              fontWeight: 400,
              view: '',
              color: '#0D71D7'
            }
          ]
        }
      ]
    },
    {
      header: '',
      subHeaders: [
        {
          header: 'Социальные сети',
          links: [
            {
              name: 'Instagram',
              url: 'https://www.instagram.com/onlinepbx.uz/?hl=ru',
              fontWeight: 400,
              view: '',
              icon: 'InstaIcon'
            },
            {
              name: 'Telegram',
              url: 'https://t.me/onlinepbx_news',
              fontWeight: 400,
              view: '',
              icon: 'TelegramIcon'
            }
          ]
        }
      ]
    }
  ]
}

export const getDocumentLinksUZ = () => {
  return [
    {
      title: 'Лицензионный договор между ООО «Chukreev PBX» и  ООО «Тесла Телеком»',
      url: process.env.PUBLIC_DIR + '/privacy/contract.pdf',
    },
    {
      title: 'Договор оферты',
      url: process.env.PUBLIC_DIR + '/privacy/oferta_uz.pdf',
    },
    {
      title: 'Политика обработки персональных данных',
      url: process.env.PUBLIC_DIR + '/privacy/conf_uz.pdf',
    },
    {
      title: 'Соглашение об участии в партнерских программах',
      url: 'https://partners.onlinepbx.ru/files/oferta.pdf',
    }
  ]
}

